<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js'
import { kenwoodItalyBasicMixin } from "../../modules/kenwood_italy_mixins_module.js";
import { sendFandomAnalyticsEvent } from "src/modules/fandom_analytics_module.js"
import shave from "shave";

// TODO:
//
// Add shave to input fields
// Add check to already selected ingredients
// Improve ingredient modal style
// Keep recipe info after accidental page refresh
//

export default {
  mixins: [fandomBasicMixin, kenwoodItalyBasicMixin],
  data: function() {
    return {
      submitInProgress: false,
      formErrors:{},
      autocompleteIngredients: [],
      modalSelectedIngredient: null,
      modalIngredientPosition: null,
      recipeInfo: {
        accessories: [''],
        allergens: [],
        cooking_modes: [],
        course: [],
        description: null,
        diets: [],
        image: null,
        ingredients: [{quantity: null, type: null},{quantity: null, type: null}],
        preparation_advice: null,
        products: [''],
        seasons: [],
        special_occasions: [],
        steps: ['', ''],
        title: null,
        info: {expence: null, difficulty: null, quantity: null },
        time: { cooking_time: null, resting_time: null, preparation_time: null },
      }
    };
  },
  mounted() {
    $('#ugc-recipe-ingredients-modal').on('hidden.bs.modal', (e) => {
      this.modalIngredientPosition = null;
      this.modalSelectedIngredient = null;
      this.autocompleteIngredients = [];
    })
  },
  methods: {
    submitRecipeUgc: function() {
      this.submitInProgress = true;
      location.hash = "";
      Fandom.ajax({
        methods: "post",
        url: "/api/v5/upload_recipe_ugc",
        processData: false,
        contentType: false,
        data: this.getRecipeDataFromModel(),
        success: (data) => {
          if(!data.response.errors) {
            // google analytics
            sendFandomAnalyticsEvent("Interaction", "Recipe Upload", this.recipeInfo.title);
            if(this.content.thank_you_page && this.content.thank_you_page.url) {
              window.location.href = this.content.thank_you_page.url;
            }
          } else {
            console.log(data.response.errors);
            location.hash = "errors";
            Vue.set(this, "formErrors", data.response.errors);
          }
          this.submitInProgress = false;
        },
        error: (jqXHR,textStatus,errorThrown) => {
          this.submitInProgress = false;
        },
      });
    },
    getRecipeDataFromModel(){
      const formData = new FormData();
      for (let [key, value] of Object.entries(this.recipeInfo)) {
        if(key == "image" || typeof(value) == "string") {
          formData.append(key, value);
        } else {
          if (value) {
            formData.append(key, JSON.stringify(value));
          }
        }
      }

      formData.append("content_id", this.content.id);
      formData.append("template_name", this.content.ugc_template);
      formData.append("upload_interaction_id", this.content.upload_interaction.interaction.id);

      return formData;
    },
    onAttachmentChange(event, fieldName) {
      Vue.set(this.recipeInfo, fieldName, event.target.files[0]);
    },
    selectCourse: function(courseName) {
      Vue.set(this.recipeInfo.course, 0, courseName);
    },
    isAddableToRecipeInfoDynamicArrays: function(arrayName, minElementsNumber = 1) {
      let array = this.recipeInfo[arrayName];
      let allCellAreFilled = true;
      for(let i = 0; i < array.length; i++){
        if (!array[i] || (array[i].hasOwnProperty('type') && array[i].type == null)){
          allCellAreFilled = false;
          break;
        }
      }
      return (allCellAreFilled && (array.length >= minElementsNumber));
    },
    isProductAddable: function(pName) {
      let products = this.recipeInfo.products;
      return (products.indexOf(pName) > -1) ? false : true;
    },
    isAccessoryAddable: function(aName) {
      let accessories = this.recipeInfo.accessories;
      return (accessories.indexOf(aName) > -1) ? false : true;
    },
    addStep: function() {
      if(this.isAddableToRecipeInfoDynamicArrays("steps", 2)) {
        this.recipeInfo.steps.push('');
      }
    },
    addNewIngredientField: function() {
      if(this.isAddableToRecipeInfoDynamicArrays("ingredients", 2)) {
        this.recipeInfo.ingredients.push({quantity: null, type: null});
      }
    },
    removeNewIngredientField: function(iIndex) {
      let ingredients = this.recipeInfo.ingredients;
      ingredients.splice(iIndex, 1);
    },
    removeStep: function() {
      let stepArray = this.recipeInfo.steps;
      if (stepArray.length > 2) {
        stepArray.pop();
      }
    },
    addProduct: function(pIndex) {
      let products = this.recipeInfo.products;
      if(products[pIndex]) {
         products.push('');
      }
    },
    removeProduct: function(pIndex) {
      let products = this.recipeInfo.products;
      products.splice(pIndex, 1);
    },
    addAccessory: function(aIndex) {
      let accessories = this.recipeInfo.accessories;
      if(accessories[aIndex]) {
         accessories.push('');
      }
    },
    removeAccessory: function(aIndex) {
      let accessories = this.recipeInfo.accessories;
      accessories.splice(aIndex, 1);
    },
    getTagIndex: function(tagName, category){
      let tagIndex = -1;
      if(Array.isArray(this.recipeInfo[category])){
        let categoryArray = this.recipeInfo[category];
        tagIndex = categoryArray.indexOf(tagName)
      }
      return tagIndex;
    },
    addOrRemoveTag: function(tagName, category) {
      let tagIndex = this.getTagIndex(tagName, category);
      if(tagIndex > -1){
        this.recipeInfo[category].splice(tagIndex, 1);
      } else {
        this.recipeInfo[category].push(tagName);
      }
    },
    openIngredientModal: function(ingredientIndex) {
      const ingredient = this.recipeInfo.ingredients[ingredientIndex];
      if(ingredient.type && ingredient.type.name ) {
        this.modalSelectedIngredient = ingredient.type;
      }
      this.modalIngredientPosition = ingredientIndex;
      $('#ugc-recipe-ingredients-modal').modal('show');
    },
    addIngredient: function(index, ingredient) {
      if(ingredient){
        Vue.set(this.recipeInfo.ingredients[index], 'type', ingredient);
        $('#ugc-recipe-ingredients-modal').modal('hide');
      }
    },
    getSearchText() {
      const vaComponent = this.$refs["v-autocomplete-ingredients-ref"];
      return vaComponent ? vaComponent.searchText : "";
    },

    autocompleteGetLabel: function(content) {
      return (content && content.title) || "";
    },

    autocompleteGetIngredients: function() {

      const params = {
        layout: "system-refs",
        layout_extra_field_name: "$empty",
        content_filtering: [["ingredienti"]],
        search_text: this.getSearchText(),
      };

      const successBlock = (data) => {
        if (data.result.main_content_name) {
          const contentName = data.result.main_content_name;
          const childrenNames = data.result.name_to_content[contentName].children;
          if (childrenNames) {
            this.autocompleteIngredients = childrenNames.map((childrenName) => {
              let ingredient = data.result.name_to_content[childrenName];
              return {
                name: ingredient.name,
                title: ingredient.title,
                id: ingredient.id
              }
            });
          } else {
            return [];
          }
        }
      };

      Fandom.post({
        data: params,
        url: "/api/v5/get_ingredients_list",
        success: (data) => {
          successBlock(data);
        }
      });

    },
    getTagChildrenInfo: function(mainTagName) {
      const childrenInfo = [];
      if(mainTagName && this.getContent(mainTagName)) {
        let childrenNames = this.getContent(mainTagName).children;
        if(childrenNames) {
          for(let i = 0; i < childrenNames.length; i++) {
            let childrenContent = this.getContent(childrenNames[i]);
            childrenInfo.push(childrenContent);
          }
        }
      }
      return childrenInfo;
    },
    getIngredient: function(ingredient){
      return ingredient.type ? ingredient.type.title : null;
    },
  },
  computed: {
    diets() {
      return this.getTagChildrenInfo(this.content.diets);
    },
    seasons() {
      return this.getTagChildrenInfo(this.content.seasons);
    },
    special_occasions() {
      return this.getTagChildrenInfo(this.content.special_occasions);
    },
    allergens() {
      return this.getTagChildrenInfo(this.content.allergens);
    },
    courses() {
      return this.getTagChildrenInfo(this.content.courses);
    },
    difficulty() {
      return this.getTagChildrenInfo(this.content.difficulty);
    },
    expence() {
      return this.getTagChildrenInfo(this.content.expence);
    },
    accessories() {
      return this.getTagChildrenInfo(this.content.accessories);
    },
    products() {
      return this.getTagChildrenInfo(this.content.products);
    },
    cooking_modes() {
      return this.getTagChildrenInfo(this.content.cooking_modes);
    },
    uploadImagePlaceHolder() {
      return (this.recipeInfo.image && this.recipeInfo.image.name) ? this.recipeInfo.image.name : "Carica la tua foto"
    },
  }
}

</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" ugc-recipe-upload >
    <div class="ugc-recipe-header container-fluid bg-cheddar">
      <div class="row py-4">
        <div class="col-12 text-center">
          <h2>{{content.title}}</h2>
        </div>
      </div>
    </div>
    <div class="ugc-recipe-form container-fluid bg-kenwood-light-grey">
      <form v-on:submit.prevent="submitRecipeUgc()">
        <div class="row justify-content-center py-4">
          <div class="col-12 col-sm-10 col-md-8 col-lg-7 col-xl-6">
            <div class="row">
              <!-- Title  -->
              <div class="col-12 pt-3 pb-4">
                <label for="title" class="font-xs text-uppercase" :class="[formErrors.title ? 'ugc-recipe-error' : '']">Titolo ricetta*</label>
                <input type="text" placeholder="Pasta al pesto" name="title" class="p-2 border-0 w-100" v-model="recipeInfo.title" requirex>
              </div>
              <!-- Description  -->
              <div class="col-12 pt-3 pb-4">
                <label for="description" class="font-xs text-uppercase" :class="[formErrors.description ? 'ugc-recipe-error' : '']">Descrizione della ricetta*</label>
                <textarea placeholder="La ricetta perfetta per ogni occasione" name="description" row="4" class="p-3 border-0 w-100" v-model="recipeInfo.description" requirex></textarea>
              </div>
              <!-- Courses  -->
              <a href="#" id="courses" class="hidden-anchor"></a>
              <div class="col-12 pt-3 pb-4">
                <label class="font-xs text-uppercase" :class="[formErrors.course ? 'ugc-recipe-error' : '']">Seleziona una portata*</label>
                 <div class="d-flex flex-wrap">
                  <div v-for="course in courses" class="course-container p-3" :class="[recipeInfo.course[0] == course.name ? 'selected': '']" @click="selectCourse(course.name)">
                    <div class="filter-url d-flex align-items-center justify-content-center">
                      <svg class="filter-icon">
                        <use :xlink:href="`#${course.icon}`"></use>
                      </svg>
                    </div>
                    <div class="font-xs text-uppercase text-center pt-3">{{course.title}}</div>
                  </div>
                </div>
              </div>
              <!-- Difficulty -->
              <a href="#" id="difficulty" class="hidden-anchor"></a>
              <div class="col-12 pt-3 pb-4">
                <label class="font-xs text-uppercase">Difficolta</label>
                <div class="d-flex custom-radio">
                  <label v-for="diff in difficulty" :key="diff.name" class="container-radio" >
                    <input type="radio" :id="diff.name" :value="diff.name" name="difficulty" class="radio-recipe-ugc" v-model="recipeInfo.info.difficulty" requirex>
                    {{diff.title}}
                  </label>
                </div>
              </div>
              <!-- Expence -->
              <a href="#" id="expence" class="hidden-anchor"></a>
              <div class="col-12 pt-3 pb-4">
                <label class="font-xs text-uppercase">Costo</label>
                <div class="d-flex custom-radio">
                  <label v-for="cost in expence" class="container-radio">
                    <input type="radio" :id="cost.name" :value="cost.name" name="expence" class="radio-recipe-ugc" v-model="recipeInfo.info.expence" requirex>
                    {{cost.title}}
                  </label>
                </div>
              </div>
              <!-- Quantity -->
              <a href="#" id="quantity" class="hidden-anchor"></a>
              <div class="col-12 pt-3 pb-4">
                <label class="font-xs text-uppercase" :class="[formErrors.quantity ? 'ugc-recipe-error' : '']">Dose per</label>
                <select v-model="recipeInfo.info.quantity" class="custom-select border-0 w-50" requirex >
                  <option disabled selected value="">Numero di persone</option>
                  <option v-for="index in 16" :value="index">{{index}} Persone</option>
                </select>
              </div>
              <!-- Ingredients -->
              <a href="#" id="ingredients" class="hidden-anchor"></a>
              <div class="col-12 pt-3 pb-4">
                <label class="font-xs text-uppercase" :class="[formErrors.ingredients ? 'ugc-recipe-error' : '']">Ingredienti*</label>
                <div v-for="(ingredient, index) in recipeInfo.ingredients" class="ingredient-container pb-3 d-flex">
                  <div class="ingredient-quantity d-flex pr-2">
                    <input type="text" v-model="recipeInfo.ingredients[index].quantity" placeholder="100g" name="ingredient_quantity" class="p-3 border-0 w-100" requirex>
                  </div>
                  <div class="ingredient-type d-flex pl-2">
                    <input type="text" placeholder="Pomodoro" :value="getIngredient(recipeInfo.ingredients[index])" name="ingredient_type" class="p-3 border-0 w-100" readonly @click="openIngredientModal(index)" requirex>
                  </div>
                  <div class="ingredient-actions d-flex align-items-center px-3">
                    <i v-if="recipeInfo.ingredients[index] && recipeInfo.ingredients.length != (index+1) && index != 0" class="fal fa-minus-circle" @click="removeNewIngredientField(index)"></i>
                    <i v-else-if="index != 0" class="fal fa-plus-circle" :class="[isAddableToRecipeInfoDynamicArrays('ingredients', 2) ? '' : 'disabled']" @click="addNewIngredientField()"></i>
                    <div v-else class="icon-placeholder"></div>
                  </div>
                </div>
              </div>
              <!-- Times -->
              <a href="#" id="times" class="hidden-anchor"></a>
              <div class="col-12">
                <!-- Preparation time -->
                <div class="d-inline-block pt-3 pr-3 pb-4 time">
                  <label for="preparation_time" class="font-xs text-uppercase" :class="[formErrors.time ? 'ugc-recipe-error' : '']">Tempo di preparazione*</label>
                  <input type="number" min="0" placeholder="minuti" name="preparation_time" class="p-3 border-0 w-100" v-model="recipeInfo.time.preparation_time">
                </div>
                <!-- Cooking time -->
                <div class="d-inline-block pt-3 pr-3 pb-4 time">
                  <label for="cooking_time" class="font-xs text-uppercase">Cottura</label>
                  <input type="number" min="0" placeholder="minuti" name="cooking_time" class="p-3 border-0 w-100" v-model="recipeInfo.time.cooking_time">
                </div>
                <!-- Resting time -->
                <div class="d-inline-block pt-3 pr-3 pb-4 time">
                  <label for="resting_time" class="font-xs text-uppercase">Riposo (per lievitati)</label>
                  <input type="number" min="0" placeholder="minuti" name="resting_time" class="p-3 border-0 w-100" v-model="recipeInfo.time.resting_time">
                </div>
              </div>
              <!-- Steps -->
              <a href="#" id="steps" class="hidden-anchor"></a>
              <div class="col-12 pt-3 pb-4">
                <label class="font-xs text-uppercase" :class="[formErrors.steps ? 'ugc-recipe-error' : '']">Preparazione*</label>
                <label class="font-xs">Inserisci la descrizione per i passaggi necessari per creare la tua ricetta.</label>
                <div class="step d-flex py-3" v-for="(step, index) in recipeInfo.steps">
                  <div class="step-index h6">{{index+1}}.</div>
                  <div class="step-description d-flex">
                    <textarea rows="3" :key="index" class="p-3 border-0 w-100" v-model="recipeInfo.steps[index]" requirex></textarea>
                  </div>
                </div>
                <div class="step-actions d-flex">
                  <div class="d-flex add-step justify-content-center align-items-center mr-2">
                    <i class="fal fa-plus-circle" :class="[isAddableToRecipeInfoDynamicArrays('steps', 2) ? '' : 'disabled']" @click="addStep()"></i>
                  </div>
                  <div class="d-flex remove-step justify-content-center align-items-center mr-2">
                    <i class="fal fa-minus-circle" :class="[recipeInfo.steps.length > 2 ? '' : 'disabled']" @click="removeStep()"></i>
                  </div>
                </div>
              </div>
              <!-- Cooking modes -->
              <a href="#" id="cooking_modes" class="hidden-anchor"></a>
              <div class="col-12 pt-3 pb-4">
                <label class="font-xs text-uppercase">Modalità di cottura</label>
                <div class="cooking-modes-container w-100 d-flex flex-wrap">
                  <div v-for="mode in cooking_modes" class="tag-element-container d-inline-block px-3 mr-2 mb-2" :class="[getTagIndex(mode.name, 'cooking_modes') > -1 ? 'selected' : '']" @click="addOrRemoveTag(mode.name, 'cooking_modes')">
                    <div class="tag-element font-sm">{{mode.title}}</div>
                  </div>
                </div>
              </div>
              <!-- Preparation advices -->
              <a href="#" id="preparation_advices" class="hidden-anchor"></a>
              <div class="col-12 pt-3 pb-4">
                <label for="preparation_advice" class="font-xs text-uppercase">Consigli</label>
                <textarea placeholder="Prova ad utilizzare il lime anziché il limone per un tocco più esotico" rows="3" name="preparation_advice" class="p-3 border-0 w-100" v-model="recipeInfo.preparation_advice"></textarea>
              </div>
              <!-- Products -->
              <div class="col-12 pt-3 pb-4">
                <label class="font-xs text-uppercase" :class="[formErrors.products ? 'ugc-recipe-error' : '']" >Prodotti kenwood utilizzati*</label>
                <div v-for="(selectedProduct, index) in recipeInfo.products" :key="`product-select-${index}`" class="product-select-container pb-3 d-flex w-100">
                  <div class="product-select d-flex">
                    <select v-model="recipeInfo.products[index]" class="custom-select border-0 w-100" requirex>
                      <option disabled selected value="">Seleziona un prodotto</option>
                      <option v-for="product in products" :disabled="!isProductAddable(product.name)" :key="`product-select-${index}-${product.name}`" :value="product.name">{{product.title}}</option>
                    </select>
                  </div>
                  <div class="product-actions d-flex align-items-center pl-3">
                    <i v-if="recipeInfo.products.length == (index+1)" class="fal fa-plus-circle" @click="addProduct(index)" :class="[isAddableToRecipeInfoDynamicArrays('products',1) ? '' : 'disabled']"></i>
                    <i v-if="recipeInfo.products[index] && recipeInfo.products.length != (index+1)" class="fal fa-minus-circle" @click="removeProduct(index)"></i>
                  </div>
                </div>
                <small class="d-block py-3">*minimo un prodotto</small>
              </div>
              <!-- Accessories -->
              <a href="#" id="accessories" class="hidden-anchor"></a>
              <div class="col-12 pt-3 pb-4">
                <label class="font-xs text-uppercase">Accessori kenwood utilizzati</label>
                <div v-for="(selectedAccessory, index) in recipeInfo.accessories" :key="`accessory-select-${index}`" class="accessory-select-container pb-3 d-flex w-100">
                  <div class="accessory-select d-flex">
                    <select v-model="recipeInfo.accessories[index]" class="custom-select border-0 w-100">
                      <option disabled selected value="">Seleziona un accessorio</option>
                      <option v-for="accessory in accessories" :disabled="!isAccessoryAddable(accessory.name)" :key="`accessory-select-${index}-${accessory.name}`" :value="accessory.name">{{accessory.title}}</option>
                    </select>
                  </div>
                  <div class="accessory-actions d-flex align-items-center pl-3">
                    <i v-if="recipeInfo.accessories.length == (index+1)" class="fal fa-plus-circle" @click="addAccessory(index)" :class="[isAddableToRecipeInfoDynamicArrays('accessories',1) ? '' : 'disabled']"></i>
                    <i v-if="recipeInfo.accessories[index] && recipeInfo.accessories.length != (index+1)" class="fal fa-minus-circle" @click="removeAccessory(index)"></i>
                  </div>
                </div>
              </div>
              <!-- Diets -->
              <a href="#" id="diets" class="hidden-anchor"></a>
              <div class="col-12 pt-3 pb-4">
                <label class="font-xs text-uppercase">Adatta alle diete</label>
                <div class="diets-container w-100 d-flex flex-wrap">
                  <div v-for="diet in diets" class="tag-element-container d-inline-block px-3 mr-2 mb-2" :class="[getTagIndex(diet.name, 'diets') > -1 ? 'selected' : '']" @click="addOrRemoveTag(diet.name, 'diets')">
                    <div class="tag-element font-sm">{{diet.title}}</div>
                  </div>
                </div>
              </div>
              <!-- Allergens -->
              <a href="#" id="allergens" class="hidden-anchor"></a>
              <div class="col-12 pt-3 pb-4">
                <label class="font-xs text-uppercase">Allergeni</label>
                <div class="allergens-container w-100 d-flex flex-wrap">
                  <div v-for="allergen in allergens" class="tag-element-container d-inline-block px-3 mr-2 mb-2" :class="[getTagIndex(allergen.name, 'allergens') > -1 ? 'selected' : '']" @click="addOrRemoveTag(allergen.name, 'allergens')">
                    <div class="tag-element font-sm">{{allergen.title}}</div>
                  </div>
                </div>
              </div>
              <!-- Special Occasions -->
              <a href="#" id="special_occasions" class="hidden-anchor"></a>
              <div class="col-12 pt-3 pb-4">
                <label class="font-xs text-uppercase">Adatta alle occasioni</label>
                <div class="special-occasions-container w-100 d-flex flex-wrap">
                  <div v-for="occasion in special_occasions" class="tag-element-container d-inline-block px-3 mr-2 mb-2" :class="[getTagIndex(occasion.name, 'special_occasions') > -1 ? 'selected' : '']" @click="addOrRemoveTag(occasion.name, 'special_occasions')">
                    <div class="tag-element font-sm">{{occasion.title}}</div>
                  </div>
                </div>
              </div>
              <!-- Seasons -->
              <a href="#" id="seasons" class="hidden-anchor"></a>
              <div class="col-12 pt-3 pb-4">
                <label class="font-xs text-uppercase">Stagioni Abbinate</label>
                <div class="special-occasions-container w-100 d-flex flex-wrap">
                  <div v-for="season in seasons" class="tag-element-container d-inline-block px-3 mr-2 mb-2" :class="[getTagIndex(season.name, 'seasons') > -1 ? 'selected' : '']" @click="addOrRemoveTag(season.name, 'seasons')">
                    <div class="tag-element font-sm">{{season.title}}</div>
                  </div>
                </div>
              </div>
              <!-- Upload img -->
              <a href="#" id="upload_img" class="hidden-anchor"></a>
              <div class="col-12 pt-3 pb-4">
                <label class="font-xs text-uppercase" :class="[formErrors.image ? 'ugc-recipe-error' : '']">Carica la foto della tua ricetta*</label>
                <label class="font-xs">Carica qui la tua foto: le più belle verranno pubblicate sui canali social di Kenwood Club Italia! Leggi sotto alcuni consigli per realizzare scatti perfetti.</label>
                <div class="custom-file">
                  <input type="file" class="custom-file-input" id="image" @change="onAttachmentChange($event, 'image')" required>
                  <label class="custom-file-label" for="image">{{uploadImagePlaceHolder}}</label>
                </div>
                <label class="font-xs text-kenwood-dark-grey pt-2">La tua foto possibilmente in formato orizzontale dal peso inferiore di 10 MB e di formato .jpg, .png o .bmp.</label>
              </div>
              <!-- Errors -->
              <a href="#" id="errors" class="hidden-anchor"></a>
              <div v-if="Object.keys(formErrors).length > 0" class="col-12 pt-3 pb-4 ugc-recipe-error">
                <label class="font-xs text-uppercase">Ti sei dimenticato qualcosa?</label>
                <div class="errors">
                  <ul>
                    <li v-for="(errorText, field) in formErrors" class="d-block">{{errorText}}</li>
                  </ul>
                </div>
              </div>
              <!-- Shots advices -->
              <div v-if="content.photo_tips" class="col-12 pt-3 pb-4">
                <label class="font-xs text-uppercase">Qualche suggerimento per i tuoi scatti</label>
                <div class="shots-advices-container w-100 d-flex flex-column">
                  <div class="shots-pictures d-flex w-100">
                    <div v-for="index in 3" class="shots-picture">
                      <img v-if="content.photo_tips[`photo_${index}`]" :src="content.photo_tips[`photo_${index}`].url" class="img-fluid">
                    </div>
                  </div>
                  <div class="shots-advices pt-3" v-if="content.photo_tips.description" v-html="content.photo_tips.description"></div>
                </div>
              </div>
              <div class="col-12 d-flex">
                <div class="row">
                  <div v-if="content.caption" class="col-12 col-sm d-flex flex-grow-1 font-xs">{{content.caption}}</div>
                  <div class="col-12 col-sm d-flex align-items-center justify-content-center pt-sm-0 pt-4">
                    <div>
                      <input type="submit" class="btn btn-cheddar" value="Invia" :disabled="submitInProgress"></input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <loading-overlay v-if="submitInProgress" :message="ft('recipe_ugc.loading')"></loading-overlay>

    <!-- Ingredients modal -->
    <div id="ugc-recipe-ingredients-modal" class="modal fade" tabindex="-1" role="dialog" ingredients-modal >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content ingredients-modal-content">
          <div class="modal-header border-0 py-3">
            <div class="container-fluid">
              <div class="row justify-content-center">
              </div>
            </div>
          </div>
          <div class="modal-body px-0">
            <div class="container-fluid">
              <div class="row justify-content-center">
                <div class="col-12 d-flex">
                  <div class="d-flex pr-3">
                    <button type="button" class="close position-static m-0 p-0" data-dismiss="modal" aria-label="Close">
                      <i aria-hidden="true" class="fal fa-arrow-left text-black"></i>
                    </button>
                  </div>
                  <div class="d-flex flex-grow-1 mr-3">
                    <v-autocomplete
                    class="w-100"
                    v-model="modalSelectedIngredient"
                    ref="v-autocomplete-ingredients-ref"
                    :keep-open="false"
                    :get-label="autocompleteGetLabel"
                    :input-attrs="{ placeholder : 'Ricerca un ingrediente Es: pollo' }"
                    component-item="page-ugc-recipe-ingredient"
                    @update-items="autocompleteGetIngredients"
                    :items="autocompleteIngredients"
                    ></v-autocomplete>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-0 d-flex justify-content-center pb-4">
            <button class="btn btn-purple-basil px-3" :disabled="!modalSelectedIngredient" @click="addIngredient(modalIngredientPosition, modalSelectedIngredient)">Aggiungi ingrediente</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>

[ugc-recipe-upload] {

  .icon-placeholder {
    width: 32px;
    height: 32px;
  }

  .ugc-recipe-form {

    .ugc-recipe-error {
      color: #f00;
    }

    label {
      display: block;
      margin-bottom: 0.85rem;
    }

    textarea {
      resize: none;
    }

    .ingredient-container {

      .ingredient-quantity {
        width: 6rem;
      }

      .ingredient-type  {
        flex-grow: 1;

        input {
          cursor: pointer;
        }

      }
    }

    .shots-advices-container {

      .shots-picture {
        width: 32%;
        margin-right: 2%;
      }

      &:last-child {
        margin-right: 0;
      }
    }

    .diets-container, .cooking-modes-container,
    .allergens-container, .special-occasions-container {
      .tag-element-container {
        transition: all 0.2s;
        cursor: pointer;
        border: 1px solid $black;
        border-radius: 1rem;

        &:hover, &.selected {
          border-color: $cheddar;
          background-color: $cheddar;
        }
      }
    }

    .product-select-container, .accessory-select-container, {

      .product-select, .accessory-select {
        flex-grow: 1;
      }

      .product-actions, .accessory-actions {
        width: 40%;
      }

    }

    .step-actions, .ingredient-actions, .accessory-actions, .product-select-container {

      i {
        font-size: 2rem;
        color: $kenwood-dark-grey;
        cursor: pointer;

        &.disabled {
          cursor: default;
          opacity: 0.2;
        }
      }
    }

    .step {

      .step-description {
        flex-grow: 1;
      }
      .step-index {
        width: 2.5rem;
      }

    }

    .step-actions {

      padding-left: 3rem;

      .add-step, .remove-step {
        width: 2.5rem;
        height: 2.5rem;
      }
    }

    .time {
      max-width: 30%;
    }

    .container-radio {
      width: 28%;
    }

    .course-container {
      width: 20%;
      transition: all 0.2s;

      &.active,
      &:active,
      &:focus,
      &:hover,
      &.selected {

        color: $cheddar;

        .filter-url {
          stroke: $cheddar;
          color: $cheddar;
        }
      }

      .filter-url {
        fill: none;
        cursor: pointer;
        stroke: $black;
        color: $black;
        transition: stroke 0.2s ease-in-out, color 0.2s ease-in-out;
        text-decoration: none;

      }

      .filter-icon {
        width: 3rem;
        height: 3rem;
      }

    }

  }

  .ingredients-modal-content {
     min-height: 400px;
  }

  @include media-breakpoint-down(lg) {
    .ugc-recipe-form {
      .product-select-container, .accessory-select-container {
        .product-actions, .accessory-actions {
          width: 25%;
        }
      }
    }
  }

  @include media-breakpoint-down(xs) {
    .ugc-recipe-form {

      .course-container {
        width: 33%;
      }

      .time {
        max-width: 48%;
      }

      .product-select-container, .accessory-select-container {
        .product-actions, .accessory-actions {
          width: auto;
        }
      }
    }
  }

}
</style>

<style lang="scss">
  [ugc-recipe-upload] {
    .v-autocomplete {
      .v-autocomplete-input-group {
        .v-autocomplete-input {
          width: 100%;
          border: none;
          background-color: $kenwood-light-grey;
          padding: 0.85rem;
        }
      }

      .v-autocomplete-list {
        width: 100%;
        overflow-y: scroll;
        max-height: 200px;
      }

    }
  }

  </style>
